import {
  AddressPage,
  GiftCardsPage,
  LoyaltyPage,
  OrdersPage,
  PaymentPage,
  ProfilePage,
} from "../pages";

// const ProfilePage = lazy(() => import("../pages/ProfilePage"));
// const AddressPage = lazy(() => import("../pages/AddressPage"));
// const PaymentPage = lazy(() => import("../pages/PaymentPage"));
// const OrdersPage = lazy(() => import("../pages/OrdersPage"));
// const LoyaltyPage = lazy(() => import("../pages/LoyaltyPage"));
// const GiftCardsPage = lazy(() => import("../pages/GiftCardsPage"));

export const privateRoutes = [
  { path: "/profile", element: <ProfilePage /> },
  { path: "/address", element: <AddressPage /> },
  { path: "/payments", element: <PaymentPage /> },
  { path: "/orders", element: <OrdersPage /> },
  { path: "/loyalty-points", element: <LoyaltyPage /> },
  { path: "/gift-cards", element: <GiftCardsPage /> },
];
